module.exports = require("@swa-ui/authentication/src/components/MfaSuccess/MfaSuccess.module.scss");